import React, { useRef, useCallback, useMemo, useState } from 'react';
import isPlainObject from 'lodash/isPlainObject';
import { Dialog } from 'primereact/dialog';
import PagePathForm from '../components/PagePathForm';
import { PrimaryButton, SecondaryButton } from '../../../components/Buttons';

import { useSelector, useDispatch } from 'react-redux';
import { savePagePath, cancelPagePath } from "../actions";
import { PAGE_TYPES } from '../components/Utils';

function getParentUrl(url) {
  if (!url) {
    return '';
  }
  const parts = url.split('/');
  parts.pop();
  return parts.join('/');
}

const PageCreationDialog = ({ history }) => {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [isFormValid, setIsFormValid] = useState(true);

  const handleValidityChange = useCallback((isValid) => {
    setIsFormValid(isValid);
  }, []);

  const isVisible = useSelector(state => state.staticPage.showPathDialog);
  const linkData = useSelector(state => state.staticPage.currentLinkData);
  const _parentUrl = useSelector(state => state.staticPage.parentUrl);
  const config = useSelector(state => state.staticPage.currentLinkDialogConfig) || {};
  const treeLinks = useSelector(state => state.staticPage.currentTreeLinks) || [];
  const routes = useSelector(state => state.staticPage.routes) || {};
  const parentUrl = _parentUrl || getParentUrl(linkData ? linkData.url : '');
  console.log('PageCreationDialog()', { isVisible, parentUrl, linkData, config, treeLinks });

  // Get sibling URLs (children of the same parent, excluding current page)
  const siblingUrls = useMemo(() => {
    const currentUrl = linkData ? linkData.url : null;
    // Flatten routes from all sections
    const allLinks = [...(routes.technik || []), ...(routes.organisation || [])];
    return allLinks
      .filter(link => {
        const linkParent = getParentUrl(link.url);
        return linkParent === parentUrl && link.url !== currentUrl;
      })
      .map(link => link.url);
  }, [routes, parentUrl, linkData]);
  console.log('PageCreationDialog() siblingUrls:', siblingUrls, 'parentUrl:', parentUrl, 'currentUrl:', linkData ? linkData.url : null);

  const onHide = useCallback(() => {
    dispatch(cancelPagePath());
  }, [dispatch]);

  const onSave = useCallback(() => {
    const data = formRef.current ? formRef.current.getModel() : null;
    if (!data) {
      return;
    }
    const { type, isProductDetailsPage } = config;
    console.log('PageCreationDialog.onSave()', { data, parentUrl });
    dispatch(savePagePath({ data, type, isProductDetailsPage },() => {
      history.replace(data.url);
    }));
  }, [config, parentUrl, history, dispatch]);

  if (!isVisible) {
    return null;
  }

  console.log('PageCreationDialog.render()', { isVisible, parentUrl, linkData, config });

  // header
  const isProduct = (config.type === PAGE_TYPES.PRODUCT);
  let title = isProduct ? 'Neues Produkt' : 'Neue Seite';
  if (linkData && linkData.url) {
    title = `${isProduct ? 'Produkt' : 'Seiten'}link bearbeiten`;
  }
  const header = (
    <div className="bg-secondary-" style={{margin: '-1em', padding: '1em'}}>
      <h3 className="no-margin">{title}</h3>
    </div>
  );
  // footer
  const footer = (
    <div className="alg-right w3-light-grey" style={{margin: '-0.571em -1em', padding: '1em'}}>
      <PrimaryButton className="margin-lft" onClick={onSave} disabled={!isFormValid}>
        {'Speichern'}
      </PrimaryButton>
      <SecondaryButton className="margin-lft" onClick={onHide}>
        {'Abbrechen'}
      </SecondaryButton>
    </div>
  );

  return (
    <Dialog
      header={header}
      footer={footer}
      iconsTemplate={null}
      visible
      style={{width: '600px'}}
      modal={true}
      onHide={onHide}
    >
      <PagePathForm
        {...config}
        ref={formRef}
        parentUrl={parentUrl}
        model={linkData}
        isEditing={isPlainObject(linkData)}
        siblingUrls={siblingUrls}
        onValidityChange={handleValidityChange}
      />
    </Dialog>
  );
};

export default PageCreationDialog;

